import { LazyImport, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "GroupEdit" */ './lazyIndex');
});
export var lazyEditGroup = new LazyImport(lazyModule, function (m) { return m.editGroup; });
//# sourceMappingURL=index.js.map